import React, { Component } from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import {
  isObject,
  values as objectValues,
  includes,
  isArray,
} from 'lodash';
import { formatMessage } from '../../lib/intl';

import { reduxForm, FormSection, FieldArray } from 'redux-form';
import { filter, times, assign } from 'lodash';
import { SINGLE_SELECT_DEFAULT_VALUE } from '../../../lib/custom-field-types';
import Purchase from '../../lib/purchase';
import { validateAllowedShareAmount } from './validate';
import renderConsumerField from '../render-consumer-field';
import ModalSplitForm from '../../containers/modal-split-form.container';
import ComitRightHandSide from '../../containers/commit-form/commit-right-hand-side.container';
import ShareInfo from '../../containers/commit-form/share-info.container';
import PayDepositOption from '../../containers/organizer-commit/pay-deposit-option.container';
import Title from '../title';
import { FORM_NAME } from './index';
import { intialSlotValuesFromDefaults } from '../../lib/desktop-member-fields-initial-values-builder';

import '../../css/datetime.css';
import '../../css/member-fields-form.css';

export const ALLOWED_MEMBER_FIELDS_PROPS = [
  'purchase',
  'currentMembership',
  'claimedSlots',
  'memberConsumerFieldSchemas',
  'initialValues',
  'allowPayDeposit',
  'payDeposit',
  'onPayDeposit',
  'onDontPayDeposit',
  'billingAddressConsumerFieldSchema',
];

const i18n = defineMessages({
  title: {
    id: 'memberFieldsForm.fieldGroups.title',
    defaultMessage: '{SlotName} {slot}',
  },
  title_adult: {
    id: 'memberFieldsForm.fieldGroups.title_adult',
    defaultMessage: 'Adult {slot}',
  },
  title_passenger: {
    id: 'memberFieldsForm.fieldGroups.title_passenger',
    defaultMessage: 'Passenger {slot}',
  },
  title_ticket: {
    id: 'memberFieldsForm.fieldGroups.title_ticket',
    defaultMessage: 'Ticket {slot}',
  },
  title_seat: {
    id: 'memberFieldsForm.fieldGroups.title_seat',
    defaultMessage: 'Seat {slot}',
  },
  title_item: {
    id: 'memberFieldsForm.fieldGroups.title_item',
    defaultMessage: 'Item {slot}',
  },
  title_shirt: {
    id: 'memberFieldsForm.fieldGroups.title_shirt',
    defaultMessage: 'Shirt {slot}',
  },
  title_person: {
    id: 'memberFieldsForm.fieldGroups.title_person',
    defaultMessage: 'Person {slot}',
  },
  title_guest: {
    id: 'memberFieldsForm.fieldGroups.title_guest',
    defaultMessage: 'Guest {slot}',
  },
  title_player: {
    id: 'memberFieldsForm.fieldGroups.title_player',
    defaultMessage: 'Player {slot}',
  },
  title_student: {
    id: 'memberFieldsForm.fieldGroups.title_student',
    defaultMessage: 'Student {slot}',
  },
});

class MemberFieldsForm extends Component {
  constructor(props) {
    super(props);

    this.formatMessage = formatMessage(this.props.intl);

    this.onSubmit = this.onSubmit.bind(this);
    this.onShareInfoChange = this.onShareInfoChange.bind(this);
    this.renderFieldGroups = this.renderFieldGroups.bind(this);
    this.resetForm = true;
    this.state = {
      payDeposit: props.payDeposit,
    };
  }

  componentWillUnmount() {
    if (this.resetForm) {
      this.props.destroy();
    }
  }

  onShareInfoChange(claimedSlots) {
    if (claimedSlots > this.claimedSlots) {
      this.populateMissingMemberFields(claimedSlots - this.claimedSlots);
    }
    if (claimedSlots < this.claimedSlots) {
      this.subtractRemovedMemberFields(this.claimedSlots - claimedSlots);
    }
    this.claimedSlots = claimedSlots;
  }

  populateMissingMemberFields(amount) {
    const { memberConsumerFieldSchemas: schemas } = this.props;
    times(amount, () => {
      this.props.array.push('memberFields.slots', intialSlotValuesFromDefaults(schemas));
    });
  }

  subtractRemovedMemberFields(amount) {
    times(amount, () => {
      this.props.array.pop('memberFields.slots');
    });
  }

  onSubmit(values) {
    this.resetForm = false;
    return this.props.onSubmit(values);
  }

  get showingDeposit() { return this.state.payDeposit; }

  dontPayDeposit() {
    this.setState({ payDeposit: false });
    this.props.onDontPayDeposit();
  }

  payDeposit() {
    this.setState({ payDeposit: true });
    this.props.onPayDeposit();
  }

  renderFieldGroups({ fields }) {
    const { purchase } = this.props;
    this.claimedSlots = fields.length;

    return (
      <div>
        {fields.map((slot, index) => (
          <div key={`field-group-${index}`}>
            <Title
              text={this.formatMessage(i18n.title, { slot: index + 1 }, purchase.slotName)}
              divider
            />
            {this.renderFieldsForSlot(slot, index)}
          </div>
        ))}
      </div>
    );
  }

  renderFieldsForSlot(slot, slotIndex) {
    return this.props.memberConsumerFieldSchemas
      .map((field, index) => {
        const f = {
          ...field,
          onChange: (e) => {
            if (e.target && e.target.value) {
              const val = e.target.value;
              if (val === "null") {
                this.props.change(FORM_NAME, `memberFields.${slot}.${field.name}`, null)
              }
            }
          }
        }
        const key = `field-${index}`;
        const name = `slots[${slotIndex}].${field.name}`;
        return renderConsumerField({ ...f, key, name })
      })
  }

  renderShareInfo() {
    if (this.props.showShareInfoInMemberFieldsForm) {
      return (
        <div className="form-group">
          <ShareInfo
            onChange={this.onShareInfoChange}
            editing
          />
        </div>
      );
    }
  }

  renderMemberFields() {
    if (!this.props.memberConsumerFieldSchemas.length) return null;

    return (
      <FormSection name="memberFields">
        <FieldArray name="slots" component={this.renderFieldGroups} />
      </FormSection>
    )
  }

  renderBilling() {
    if (!this.props.billingAddressConsumerFieldSchema) return null;

    return renderConsumerField({
      ...this.props.billingAddressConsumerFieldSchema,
      key: `field-billing-address`
    })
  }

  renderSkipForNow() {
    if (!this.props.allowSkip) return null;

    return (
      <button
        type="submit"
        className="btn btn-link text-muted px-0 skip-for-now"
        disabled={this.props.submitDisabled}
        onClick={() => {
          this.props.change('skip', true);
          return true;
        }}
      >
        <FormattedMessage
          id="memberFieldsForm.skipButton"
          defaultMessage="Skip for now"
        />
      </button>
    );
  }

  renderForm() {
    const { handleSubmit } = this.props;

    return (
      <div className="member-fields-form">
        <form onSubmit={handleSubmit(this.onSubmit)}>
          {this.renderShareInfo()}


          <div className="field-schemas-container">
            <PayDepositOption
              onDeposit={() => this.payDeposit()}
              onNoDeposit={() => this.dontPayDeposit()}
              shouldRender={this.props.allowPayDeposit}
            />

            {this.renderMemberFields()}

            {this.renderBilling()}
          </div>

          <div className="row form-footer">
            <div className="col-12"><hr /></div>
            <div className="col-4 height-adjuster" />
            <div className={this.props.allowSkip ? "col-4 flex-last" : "col-8"}>
              <button
                type="submit"
                className="btn btn-primary pull-right"
                onClick={() => {
                  this.props.change('skip', false);
                  return true;
                }}
              >
                <FormattedMessage
                  id="memberFieldsForm.submit"
                  defaultMessage="Continue"
                />
              </button>
            </div>
            <div className="col-4">
              {this.renderSkipForNow()}
            </div>
          </div>
        </form>
      </div>
    )
  }

  renderRightHandSide() {
    return null;
  }

  render() {
    return (
      <ModalSplitForm
        leftForm={this.renderForm()}
        rightForm={<ComitRightHandSide showingDeposit={this.showingDeposit} />}
      />
    );
  }
}

MemberFieldsForm.defaultProps = {
  allowSkip: false,
  payDeposit: false,
  onSubmit: () => { },
  onPayDeposit: () => { },
  onDontPayDeposit: () => { },
};

const validateSlot = (slot, requiredFieldNames) => {
  const errors = {}

  requiredFieldNames.forEach((field) => {
    const value = slot[field];

    if (!value
      || value === SINGLE_SELECT_DEFAULT_VALUE
      || value === "null"
      || value === " ") {
      errors[field] = 'This field is required';
    }

    if (isObject(value) && !value._isAMomentObject && !isArray(value)) {
      const values = objectValues(value);
      if (includes(values, undefined) || includes(values, null) || includes(values, "")) {
        errors[field] = 'This field is required';
      }
    }

    if (isArray(value) && value.length === 0) {
      errors[field] = 'This field is required';
    }

  });

  return errors;
};

const validate = (values, props) => {
  if (values.skip) return {};

  const requiredFields = filter(props.memberConsumerFieldSchemas, { required: true });
  const requiredFieldNames = requiredFields.map(field => field.name);
  const errors = { memberFields: { slots: {} } };
  const { purchase } = props;
  const { group } = purchase;
  const isSpecifiedPerPerson = Purchase.isSpecifiedPerPerson(group.splitType);

  values.memberFields.slots.forEach((slot, index) => {
    errors.memberFields.slots[index] = validateSlot(slot, requiredFieldNames);
  });

  if (props.billingAddressConsumerFieldSchema && props.billingAddressConsumerFieldSchema.required) {
    if (!values[props.billingAddressConsumerFieldSchema.name]
      || values[props.billingAddressConsumerFieldSchema.name] === SINGLE_SELECT_DEFAULT_VALUE
      || values[props.billingAddressConsumerFieldSchema.name] === "null"
      || values[props.billingAddressConsumerFieldSchema.name] === " ") {
      errors[props.billingAddressConsumerFieldSchema.name] = 'This field is required';
    }

    if (isObject(values[props.billingAddressConsumerFieldSchema.name])) {
      const _values = objectValues(values[props.billingAddressConsumerFieldSchema.name]);
      if (includes(_values, undefined) || includes(_values, null) || includes(_values, "")) {
        errors[props.billingAddressConsumerFieldSchema.name] = 'This field is required';
      }
    }
  }

  if (isSpecifiedPerPerson && values.allowedShareAmount) {
    assign(errors, validateAllowedShareAmount(values, props));
  }

  return errors;
};

export default injectIntl(reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  validate
})(MemberFieldsForm));



// WEBPACK FOOTER //
// ./src/desktop/components/commit-form/member-fields-form.js